import { useState, useEffect, memo } from "react";
import AnimacionCarga from "./animacion_de_carga";
import TablaGenerica from "./tablas";
import { CSVLink } from "react-csv";
import BotonSOS from "./sos/boton_sos";
import { obtenerEventos } from "../../functions/consultas";
import "bootstrap-icons/font/bootstrap-icons.css";

const columnas = [
  { label: "Título", key: "nombre_evento" },
  { label: "Dirección", key: "sitio_evento" },
  { label: "Asunto", key: "asunto_notificacion" },
  { label: "Correo electrónico", key: "correo_seguimiento" },
  { label: "Foto", key: "url_banner_foto" }
];

const ListadoEventos = memo(() => {
  const [datos, setDatos] = useState([]);
  const [cargando, setCargando] = useState(true);

  const capturarDatos = async () => {
    try {
      const data = await obtenerEventos();
      setDatos(Array.isArray(data) ? data : Object.values(data || {}));
    } catch (error) {
      console.error(error);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { capturarDatos(); }, []);

  return cargando ? (
    <AnimacionCarga />
  ) : (
    <>
      <TablaGenerica
        datos={datos}
        titulos={columnas.map(c => c.label.toUpperCase())}
        campos={columnas.map(c => c.key)}
        elementosPorPagina={3000}
        columnaOrdenInicial={0}
        direccionOrdenInicial="desc"
        contenidoExtra={
          <div style={{ marginLeft: "auto", display: "flex", gap: 0 }}>
            <button onClick={capturarDatos} title="Refrescar"><i className="bi bi-arrow-clockwise" /></button>
            <CSVLink data={datos} headers={columnas} filename="listado_eventos.csv" separator=";" style={{ padding: "7px 14px", margin: 2, backgroundColor: "#c0392b", color: "#fff", borderRadius: 7, fontSize: "0.82rem", fontWeight: 500, textDecoration: "none" }} title="Exportar"><i className="bi bi-download" /></CSVLink>
          </div>
        }
      />

      <BotonSOS />
    </>
  );
});

export default ListadoEventos;
